import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=0d48a3ec&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=0d48a3ec&prod&scoped=true&lang=css"
import style1 from "./Breadcrumb.vue?vue&type=style&index=1&id=0d48a3ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48a3ec",
  null
  
)

export default component.exports